import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { ICountryState } from './country.state';

export class CountrySelectors {
  // todo: replace any type state with root state (once defined)
  static readonly countryState = (state: IRootState): ICountryState => {
    return state.country as ICountryState;
  };

  static readonly model = createSelector(CountrySelectors.countryState, (country: ICountryState) => {
    return country.model;
  });

  static readonly data = createSelector(CountrySelectors.countryState, (country: ICountryState) => {
    return country.data;
  });
}
